import Button from '@atoms/Button/Button';
import Icon, { IconLanguage } from '@atoms/Icon';
import { UserLang } from '@constants/common';
import { useRenderLanguage } from '@hooks';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import './LanguageSwitcher.scss';

interface Props {
    theme?: 'dark' | 'white';
    variant?: 'short' | 'full';
    size?: 'xxs' | 'xs';
    onClick: VoidFunction;
}

const LanguageSwitcherController: React.FC<Props> = ({
    onClick,
    theme = 'dark',
    variant,
    size = 'xs',
}) => {
    const { i18n } = useTranslation();
    const { renderLanguageByUserLang } = useRenderLanguage();

    return (
        <Button
            onClick={onClick}
            classes="Popover-LanguageSwitcherController global_theme-green"
            id="Popover-LanguageSwitcher"
            label={renderLanguageByUserLang(
                i18n.language as UserLang,
                variant === 'short'
            )}
            icon={<Icon icon={<IconLanguage />} theme={theme} size={size} />}
            variant="outlined"
            theme={theme}
            size={size}
            radius={size}
        />
    );
};

export default LanguageSwitcherController;
